module.exports = __webpack_public_path__ + "img/robinson-white.b397beb9.svg";